import React, { Component } from 'react';

// import Tabs from '../../components/Tab';
import { Wrapper } from './style';
import Pairs from './Pairs';
// import Volumes from './Volumes';
// import ActiveOrders from './ActiveOrders';
import { getTabParams } from '../../common/utils'

class Trading extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabParams: getTabParams(),
            hideTabs: false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const tabParams = getTabParams();
        if (JSON.stringify(this.props.location) !== JSON.stringify(prevProps.location) &&
            JSON.stringify(tabParams) !== JSON.stringify(this.state.tabParams)) {
            this.setState({ tabParams });
        }
    }

    handleTabChange = (key) => {
        this.setState({ tabParams: { ...this.state.tabParams, tab: key } });
    };

    handleHide = (value) => {
        this.setState({ hideTabs: value });
    };

    renderTabBar = (props, DefaultTabBar) => {
        if (this.state.hideTabs) return <div></div>;
        return (
            <DefaultTabBar {...props} />
        );
    };

    render () {
        // const { tabParams } = this.state;
        // const TradingTabList = [
        //     {
        //         key: 'pairs',
        //         name: 'Pairs',
        //         content: <Pairs location={this.props.location} handleHide={this.handleHide} />
        //     },
        //     {
        //         key: 'volumes',
        //         name: 'Volumes',
        //         content: <Volumes />
        //     },
        //     {
        //         key: 'active orders',
        //         name: 'Active orders',
        //         content: <ActiveOrders />
        //     },
        // ]
        return (
            <Wrapper>
                <div className="main-header">
                    Markets
				</div>
                {/* <Tabs
                    TabList={TradingTabList}
                    activeTab={tabParams.tab}
                    onChange={this.handleTabChange}
                    renderTabBar={this.renderTabBar}
                /> */}
                <Pairs location={this.props.location} handleHide={this.handleHide} />
            </Wrapper>
        )
    }
}

export default Trading;
